import React from 'react';

import { Consent, PartnerMap, PendingConsent } from 'src/reducers/partner/types';

import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
const backToOtherConnections = (
  partners: PartnerMap,
  connected: Consent[],
  pendingConnections: PendingConsent[]
) => {
  mediator.publish('partner:navigateOtherConnections', {
    partners,
    connected,
    pending: pendingConnections,
  });
};

type Props = {
  partners: PartnerMap;
  connected: Consent[];
  pendingConnections: PendingConsent[];
};

const DoneButton: React.FC<React.PropsWithChildren<Props>> = ({
  partners,
  connected,
  pendingConnections,
}) => {
  return (
    <button
      id="connectedPartner-done-btn"
      className="btn btn-lg btn-primary"
      onClick={() => {
        backToOtherConnections(partners, connected, pendingConnections);
      }}
    >
      {i18n.t('Common.done', { context: 'cap' })}
    </button>
  );
};

export default DoneButton;
